import type { TableColumn } from 'uikit';

import * as R from 'ramda';
import { useMemo } from 'react';

const sortLinkedActs = (array: TableColumn<any>[]): TableColumn<any>[] =>
    // @ts-ignore
    R.pipe(R.sortBy(R.prop('id')), R.reverse)(array);

export const useLinkActs = ({ seasonColumns, actColumns }: { seasonColumns: any[]; actColumns: any[] }) =>
    useMemo(
        () =>
            seasonColumns.reduce(
                (acc: TableColumn<any>[], column: (TableColumn<any> & { seasonId: number }) | TableColumn<any>) => {
                    const { seasonId } = Array.isArray(column) ? column[0] : column;
                    const linkedActs = sortLinkedActs(actColumns.filter((act) => act.seasonId === seasonId));

                    if (Array.isArray(column)) {
                        acc.push(...column, ...linkedActs);
                    } else {
                        acc.push(column, ...linkedActs);
                    }

                    return acc;
                },
                [],
            ),
        [actColumns, seasonColumns],
    );
